import { CalculatedDimension } from "./calculated-dimension";

export class FixedDimension extends CalculatedDimension {
  constructor(value) {
    super();
    this.value = value;
  }

  isEquals(other) {
    return this.value == other.value;
  }

  isNeedUpdate(/*parentDimension*/) {
    return false;
  }

  calcValue(/*parentDimension*/) {
    return this.value;
  }

  copy() {
    return new FixedDimension(this.value);
  }
}
